import { Injectable, signal } from '@angular/core';

/** Rótulos de entidades (UUID) para exibição no breadcrumb. */
@Injectable({ providedIn: 'root' })
export class BreadcrumbContextService {
  private readonly labels = signal<Record<string, string>>({});

  setLabel(id: string, label: string): void {
    this.labels.update((m) => ({ ...m, [id]: label }));
  }

  getLabel(id: string): string | undefined {
    return this.labels()[id];
  }
}
